
















import { Vue, Component } from 'vue-property-decorator'
import FilterForm from '@/components/LayerFilterForms/FilterForm.vue'
import { search, storage } from '@/store/modules'
import { InfoBundle } from '@/orrm/model/info-bundle'
import { InfosFilterCriteria } from '@/store/search'

@Component({
  components: { FilterForm }
})
export default class InfosFilterForm extends Vue {
  get criterias (): InfosFilterCriteria {
    return search.infoCriterias
  }

  get infoBundles (): InfoBundle[] {
    return storage.infoBundles
  }

  get loadingInfoBundles (): boolean {
    return storage.loadingInfoBundles
  }

  async created () {
    await storage.initInfoBundles()
  }
}
